/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable camelcase */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-underscore-dangle */
import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import Select from "@alboompro/boom-components/data-entry/select";
import { ButtonBuilder as PaymentButtonBuilder } from "@alboom/payment-button-builder-vitejs"
import Icon from "@alboompro/boom-components/general/icon";
import {
  ConfigurePayAccountWrapper,
  CustomPropListItem,
  EditPaymentButton,
  NewPaymentButton,
  Option
} from "./styles";

class PaymentButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      newPaymentButton: true,
    };
  }

  formatOptions = () => {
    const {
      editorData: { data: { orders = [] } },
    } = this.props;
    const opts = orders.map((button) => ({
      label: <Option>{button.name}</Option>,
      value: button._id,
    }));
    opts.push({
      value: "new_payment_button",
      label: (
        <NewPaymentButton>
          <Icon
            kind="bold"
            group="interface-essential"
            category="remove-add"
            file="add-circle.svg"
            size="14"
            color="#50AFF4"
          />
          <span>{I18n.t("editPanel.paymentButton.createNewButton")}</span>
        </NewPaymentButton>
      ),
      props: { onClick: () => this.onOpenModal("newButton")  }
    });
    return opts;
  };

  handleChange = ({ value }) => {
    const { updaterFn, name } = this.props;
    if (value !== "new_payment_button") {
      updaterFn({ prop: name, value });
      this.setState({ newPaymentButton: false })
    } else {
      this.setState({ newPaymentButton: true });
    }
  };

  onOpenModal = action => {
    this.setState({ visible: true, newPaymentButton: action === "newButton" });
  }

  onCloseModal = () => {
    this.setState({ visible: false, newPaymentButton: false });
  }

  handleUpdate = (newPaymentButton) => {
    const {
      currentValue,
      store,
      editorData: { data: { orders = [], hasPayAccount } },
      updaterFn,
      name,
    } = this.props;
    const normalizedPaymentButton = { _id: newPaymentButton._id, name: newPaymentButton.name }
    if (orders && orders.length) {
      const hasItem = orders.filter((button) => button._id === normalizedPaymentButton._id);
      const newItems = hasItem.length
        ? orders.map((button) => (button._id === normalizedPaymentButton._id ? normalizedPaymentButton : button))
        : orders.concat(normalizedPaymentButton);
      store.update({ success: true, data: { orders: newItems, hasPayAccount } });
    } else {
      store.update({ success: true, data: { orders: [normalizedPaymentButton], hasPayAccount} });
    }

    // trigger update function within element if the current
    // paymentButton is the one that was updated
    if (currentValue === normalizedPaymentButton._id) {
      store.trigger("paymentButtonUpdated", normalizedPaymentButton);
    }

    updaterFn({ prop: name, value: normalizedPaymentButton._id });
  };

  renderConfigurePayAccount = () => {
    return (
      <ConfigurePayAccountWrapper>
        <p>{I18n.t("editPanel.paymentButton.configureAccountText")}</p>
        <a href="https://pay.alboompro.com" target="_blank" rel="noopener noreferrer">
          <span>{I18n.t("editPanel.paymentButton.configureAccountCTA")}</span>
          <Icon
            kind="bold"
            group="arrows-diagrams"
            category="arrows"
            file="arrow-right-1.svg"
            size="10"
            color="#50AFF4"
          />
        </a>
      </ConfigurePayAccountWrapper>
    )
  }

  renderNoButtonCreated = () => {
    return (
      <ConfigurePayAccountWrapper>
        <p>{I18n.t("editPanel.paymentButton.createButtonText")}</p>
        <button type="button" className="edit-payment-button-btn" onClick={() => this.onOpenModal("newButton")}>
          <span>{I18n.t("editPanel.paymentButton.createButtonCTA")}</span>
          <Icon
            kind="bold"
            group="arrows-diagrams"
            category="arrows"
            file="arrow-right-1.svg"
            size="10"
            color="#50AFF4"
          />
        </button>
      </ConfigurePayAccountWrapper>
    )
  }

  renderPropContent = () => {
    const { label, locale, currentValue, editorData: { data } } = this.props;
    const { hasPayAccount, orders: paymentButtons } = data || {};

    if(hasPayAccount === false) {
      return this.renderConfigurePayAccount()
    }

    if(paymentButtons && !paymentButtons.length) {
      return this.renderNoButtonCreated();
    }

    return (
      <>
        <Select
          label={label[locale]}
          value={currentValue}
          placeholder={I18n.t("general.select")}
          options={paymentButtons ? this.formatOptions() : []}
          disabled={!paymentButtons}
          onChange={this.handleChange}
          optionsStyle={{
            fontWeight: 400,
            padding: 0,
            height: 33,
            fontSize: 12,
            position: "relative"
          }}
          selectClassName="payment-button-list-select"
          selectStyle={{
            backgroundColor: "#fff",
            padding: "8px 12px",
            height: 34,
            border: "1px solid #ebebeb",
            borderRadius: "3px",
            fontSize: 12,
            lineHeight: 1.5,
          }}
          dropdownClassName="payment-button-list-dropdown"
          dropdownStyle={{
            borderRadius: "3px",
            transform: "translateY(3px)",
            border: "1px solid #ebebeb",
            padding: 4,
          }}
        />
        <EditPaymentButton className="edit-payment-button-btn" onClick={this.onOpenModal}>
          <Icon
            kind="light"
            group="interface-essential"
            category="edit"
            file="pencil-1.svg"
            size="12"
            color="#3E3E3E"
          />
        </EditPaymentButton>
      </>
    )
  }

  render() {
    const { visible, newPaymentButton } = this.state;
    const { locale, currentValue } = this.props;

    return (
      <CustomPropListItem>
        {this.renderPropContent()}

        <PaymentButtonBuilder
          visible={visible}
          onClose={this.onCloseModal}
          paymentButtonId={newPaymentButton ? "" : currentValue}
          onUpdate={this.handleUpdate}
          language={locale}
        />
      </CustomPropListItem>
    );
  }
}

export default PaymentButton;
